import {TOOLTIP_POSITION} from '@Components/tooltip/tooltip';

export const getClassesForPosition = (position: TOOLTIP_POSITION): string => {
  switch (position) {
    case TOOLTIP_POSITION.TOP_MIDDLE:
      return 'top';
    case TOOLTIP_POSITION.TOP_RIGHT:
      return 'top right';
    case TOOLTIP_POSITION.TOP_LEFT:
      return 'top left';
    case TOOLTIP_POSITION.BOTTOM_LEFT:
      return 'left';
    case TOOLTIP_POSITION.BOTTOM_RIGHT:
      return 'right';
    default:
      return '';
  }
};
